export const Operator = (value) => ({
    pipe(...fns) {
        return fns.reduce((acc, curr) => curr(acc), value);
    },
});
